<template>
  <div class="tutucu">
    <vs-card>
      <vs-table class="gosterme" stripe :data="list3">
            <template slot="header">
              <h3>Etkinlik Bilgileri</h3>
            </template>
            <template slot="thead">

               <vs-th>Tarih</vs-th>
                <vs-th>Saat</vs-th>
                 <vs-th>Yer</vs-th>
                <vs-th>Etkinlik Türü</vs-th>
               <vs-th>Etkinlik Adı</vs-th>
               <!--<vs-th>Sürdürülebilir Kalkınma Amaçları</vs-th> -->
                <vs-th>Bağlı Olduğu Etkinlik</vs-th>

            </template>
            <template slot-scope="{data}">
              <vs-tr v-for="(item, i) in data" :key="i" >

                 <vs-td :data="item.startDate">
                  <div class="fontt" @click="show(item, i)">{{ item.startDate }}</div>
                </vs-td>
                 <vs-td :data="item.startTime">
                  <div class="fontt" @click="show(item, i)">{{ item.startTime }}</div>
                </vs-td>
                  <vs-td :data="item.room">
                  <div class="fontt" @click="show(item, i)">{{ item.room }}</div>
                </vs-td>
                 <vs-td :data="item.eventType">
                  <div class="fontt" @click="show(item, i)">{{ item.eventType }}</div>
                </vs-td>

                   <vs-td :data="item.eventName">
                  <div class="fontt" @click="show(item, i)">{{ item.eventName }}</div>
                </vs-td>
                  <!--<vs-td :data="item.relations">
                  <div class="fontt" @click="show(item, i)">{{ item.relations }}</div>-->
                </vs-td>
                 <vs-td :data="item.relatedEvent">
                  <div class="fontt" @click="show(item, i)">{{ item.relatedEvent }}</div>
                </vs-td>
                
                   <vs-td :data="item">
                    <vs-button  color="warning" icon-pack="mdi" icon="mdi-favorite" @click="detayaGit(item)">Detaylar</vs-button>
                  </vs-td>

                 <vs-td :data="item.id">
                                 <vs-button class="butonlar"  color="danger" icon-pack="mdi" icon="mdi-favorite"  @click="silmeYap(item.id)">Sil</vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

       <div class="text-center"><h4>ANKARA HACI BAYRAM VELİ ÜNİVERSİTESİ ETKİNLİK YÖNETİM SİSTEMİ</h4></div>
    </vs-card>
    <vs-button @click="aramaFunc()"  class="aramabutton">Detaylı Arama</vs-button>

    <vs-button :to="{name: 'Etkinliklerim'}" color="#32bebe" class="oldEvent">Katıldığım Etkinlikler</vs-button>
    <vs-button  :to="{name: 'Yeni Etkinlik'}" color="#46c93a" class="newEvent">Yeni Etkinlik</vs-button>
    <div class="tutucu2">
     <vs-card v-if="arama" class="cardxy">

          <div slot="header">
            <h4>
              Detaylı Arama
            </h4>
          </div>
          <div class="aramasalon">
             <vs-select
                  label="Salon Listesi"
                  placeholder="Salon Seçiniz"
                  autocomplete
                  class="elementSalon2"
                  v-model="aranacakSalon"
                  >
                  <vs-select-item :key="index" :value="item.roo" :text="item.roo" v-for="item,index in  this.gonderilecek3" />
                </vs-select>

          <div class="tarihler">

        <vs-input
            class="tar11"
            label="Başlangıç Tarihi (DD/MM/YYY)"
            v-model="aranacakTarih1"
            type="date"

        />
        <vs-input
            class="tar11"
            label="Bitiş Tarihi (DD/MM/YYY)"
            v-model="aranacakTarih2"
            title="endDate"
            name="endDate"
            id="endDate"
             type="date"
        />
           </div>
          </div>
           <div class="radiolar">
          <div class="aramaTurRoof">
            <div class="turClass">
             <vs-input
             label="Etkinlik Kayıt No"
            class="minn"
              v-model="etkinlikId"


          />
                            <br><br>

     <!-- <vs-select
                    placeholder="Etkinlik Tür"
                    label="Etkinlik Türü:"
                    autocomplete
                    class="widthsel"
                    v-model="optionsetkinlikTemelTemp"
                    >

                    <vs-select-item :key="index" :value="item" :text="item"   v-for="item,index in this.optionsetkinlikTemel" />
                  </vs-select>-->
                  <br><br>

                  <vs-select
                    placeholder="Etkinlik Tür Alt Başlıkları"
                    label="Tür Alt Başlık"
                     class="widthsel"
                    autocomplete
                    v-model="optionsetkinliktemp"
                    >
                    <vs-select-item :key="index" :value="item" :text="item" v-for="item,index in this.optionsetkinlikDegisken" />
                  </vs-select>
                   <br><br>
                  <vs-select
                   class="widthsel2"
                    placeholder="Etkinlik Tür Detayları"
                    label="Tür Detay"
                    autocomplete
                    
                    v-model="digertemp"
                    >

                    <vs-select-item :key="index" :value="item" :text="item" v-for="item,index in optionsabstract" />
                  </vs-select>

                   </div>




          </div>

          <div class="arama1ttt">
          Hedef Kitle:
               <v-checkbox  label="Akademik Personel" class="studentp2" v-model="aramaAkademik">

      </v-checkbox>
      <v-checkbox  label="İdari Personel" class="studentp2" v-model="aramaIdari">

      </v-checkbox>
        <v-checkbox  label="Öğrenci" class="studentp2" v-model="aramaOgrenci">

      </v-checkbox>
      <v-checkbox  label="Diğer" class="studentp2" v-model="aramaDiger">

      </v-checkbox>
       <div class="dotMyst">. </div>
          </div>

          <div class="arama1ttt">
          Dil:
                <v-checkbox  label="Türkçe" class="studentp2" v-model="aramaTurkce">

              </v-checkbox>
              <v-checkbox  label="İngilizce" class="studentp2" v-model="aramaIngilizce">

              </v-checkbox>
                <v-checkbox  label="Arapça" class="studentp2" v-model="aramaArapca">

              </v-checkbox>
              <v-checkbox  label="Almanca" class="studentp2" v-model="aramaAlmanca">

            </v-checkbox>
             <div class="dotMyst">. </div>
          </div>
           </div>


            <div class="radiolar33">
          <div class="arama2">

             <vs-input
             label="Minimum Değer"
            class="minn"
              v-model="min"


          />
           <vs-input
           label="Maximum Değer"
              class="maxx"
              v-model="max"


          />

          </div>
          <div class="aramaFon">
          Fon Türü:
      <v-checkbox  label="TL ₺" class="studentp" v-model="paraTl">

      </v-checkbox>
      <v-checkbox  label="Dolar $" class="studentp" v-model="paraDolar">

      </v-checkbox>
        <v-checkbox  label="Euro €" class="studentp" v-model="paraEuro">

      </v-checkbox>
      <v-checkbox  label="Sterlin £" class="studentp" v-model="paraSterlin">

      </v-checkbox>


          </div>
           </div>
          <div class="yardimRadio">
          <div class="radiolar331">
          <div class="aramaFon">
           <div class="baslik"> Kurum İçi/Dışı:  </div>
      <v-checkbox  label="Kurum İçi" class="studentp" v-model="aramaKurumici">

      </v-checkbox>
      <v-checkbox  label="Kurum Dışı" class="studentp" v-model="aramaKurumdisi">

      </v-checkbox>


          </div>
           </div>
           <div class="radiolar332">
          <div class="aramaFon2">
                <div class="baslik"> Ulusal/Uluslararası:  </div>
      <v-checkbox  label="Ulusal" class="studentp" v-model="aramaUlusal">

      </v-checkbox>
      <v-checkbox  label="Uluslararası" class="studentp" v-model="aramaUluslararasi">

      </v-checkbox>
          </div>
           </div>
                 </div>
                 <div class="yardimRadio2">
          <div class="radiolar3312">
           <div class="baslik">
           Sıklık: </div>
          <div class="aramaFon">
            <v-checkbox class="d-inline-block" label="Bir Kez"  v-model="aramaBirkez">

      </v-checkbox>

      <v-checkbox class="d-inline-block" label="Günlük"  v-model="aramaGunluk">

      </v-checkbox>
      <v-checkbox  class="d-inline-block" label="Aylık"  v-model="aramaAylik">

      </v-checkbox>

       <v-checkbox  class="d-inline-block" label="Yıllık"  v-model="aramaYillik">

      </v-checkbox>
      <v-checkbox  class="d-inline-block" label="Hepsi" v-on:change="hepsi1()"  v-model="aramaHepsi">

      </v-checkbox>
          </div>
           </div>
           <div class="radiolar3322">
            <div class="baslik">
           Etkinlik Ortamı: </div>
          <div class="aramaFon">
            <v-checkbox class="d-inline-block" label="Hibrit"  v-model="aramaHibrit">

      </v-checkbox>
      <v-checkbox  class="d-inline-block" label="Dijital"  v-model="aramaDijital">

      </v-checkbox>

       <v-checkbox  class="d-inline-block" label="Yüz Yüze"  v-model="aramaYuzyuze">

      </v-checkbox>
      <v-checkbox  class="d-inline-block" label="Hepsi" v-on:change="hepsi2()" v-model="aramaHepsi2">

      </v-checkbox>
          </div>
           </div>
            <div class="radiolar3322">
          <div class="baslik">
           Etkinlik Durumu: </div>
          <div class="aramaFon">
            <v-checkbox class="d-inline-block" label="Onaylı"  v-model="aramaOnayli">

      </v-checkbox>
      <v-checkbox  class="d-inline-block" label="Onaylı Değil"  v-model="aramaOnaysiz">

      </v-checkbox>
      <v-checkbox  class="d-inline-block" label="Hepsi"  v-on:change="hepsi3()" v-model="aramaHepsi3">

      </v-checkbox>


          </div>

           </div>

                 </div>
                 <div class="aramaButonu">
                     <vs-button   color="#46c93a" class="girisbuton"  @click="aramaParametre()">Sonuçları Göster</vs-button>

                 </div>
              </vs-card>

         </div>
   <!--  <vs-divider ></vs-divider>
    <div class="text-center"><h5>Katılımcı Dağılımı</h5></div>

    <br>
    <States/>
    <br>
    <vs-divider ></vs-divider>
    <div class="text-center"><h5>Etkinlik Dağılımı</h5></div>
    <br>
    <Etkinlikler/>
             <vs-divider ></vs-divider>
              <br>
               <br>
    <vs-row vs-justify="center">
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" code-toggler>
        <vs-card class="cardx">
          <div slot="header">
            <h4>
              Aylara Göre Katılımcı - Etkinlik Grafiği
            </h4>
          </div>
          <div>
            <SalesSummary/>
          </div>

        </vs-card>
      </vs-col>
     <!--<vs-col type="flex" vs-justify="center" vs-align="center" vs-sm="12" vs-lg="12" vs-xs="12">
        <vs-card class="cardx">
          <div slot="header">
            <h4>
              Sales Income
            </h4>
          </div>
          <div>
            <SalesIncome/>
          </div>
        </vs-card>
      </vs-col>

      <vs-col vs-lg="12">
        <vs-card>
          <div slot="header">
            <h4>En Çok Katılım Sağlanan Etkinlikler</h4>
          </div>
          <TopProducts/>
        </vs-card>
      </vs-col> -->
       <vs-card  class="cardxyz">

          <div slot="header">
            <h5 class="yaziLine">
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Sn <div class="kirmizi">{{user.adKullaniciAdi}}</div> bu uygulamada;
             etkinlik oluşturabilir, etkinliklere görevli olarak kendinizi ekleyebilir, düzenlenmiş etkinlikler hakkında talep-öneri-şikayet iletebilir, etkinlik ile ilgili doküman ekleyebilir ve
             kendi oluşturduğunuz etkinlikleri görüntüleyebilirsiniz.
            </h5>
          </div>

              </vs-card>
    </vs-row>


  <div style="height:100%; display: flexbox; margin-left:10%;">
      <div style="height:12%; width:80%; text-align:center; align-self:center;  bottom: 0" >Öğrenci kullanıcı kılavuzu için<a href="https://eys.hacibayram.edu.tr:8081/public/ogrenci.pdf" target="_blank"> tıklayınız</a></div>
      <div style="height:10%; width:80%; text-align:center; align-self:center;   bottom: 0" >Personel kullanıcı kılavuzu için <a href="https://eys.hacibayram.edu.tr:8081/public/personel.pdf" target="_blank"> tıklayınız</a></div>
    </div>
  </div>
</template>

<script>
  import SalesSummary from "@/components/dashboard/SalesSummary";
  import SalesIncome from "@/components/dashboard/SalesIncome";
  import TopProducts from "@/components/dashboard/TopProducts";
  import States from "@/components/dashboard/States";
  import Etkinlikler from "@/components/dashboard/Etkinlikler";
  import Blogs from "@/components/dashboard/Blogs";
  import User from "@/libs/users/User";
    import Roo from "@/libs/roos/Roo";

import { isAuthenticated, getUserFromStorage } from '@/utils/Customs'
  import { paginatorMixin } from "@/mixins/paginatorMixin";


  export default {

    name: 'Home',
    title: 'Anasayfa',
     mixins: [
      paginatorMixin,
    ],
    components: {
      SalesSummary,
      SalesIncome,
      TopProducts,
      States,
      Etkinlikler,
      Blogs
    },
    data:() => ({
      user: getUserFromStorage(),

         obj: new User(),
          obj3: new Roo(),
          arama:false,
           max:null,
            min:0,
            etkinlikId:'',
            gonderilecek3:[],
            digertemp:'',
           optionsetkinliktemp:'',
            aranacakSalon:'',
            nameSurname:'',
            aranacakTarih1:'2022-01-01',
            aranacakTarih2:'2022-01-01',
            aramaKonser:false,
            aramaSinema:false,
            aramaTiyatro:false,
            aramaSergi:false,
            aramaAkademik:false,
            aramaIdari:false,
            aramaOgrenci:false,
            aramaDiger:false,
            aramaTurkce:false,
            aramaIngilizce:false,
            aramaArapca:false,
            aramaAlmanca:false,

            paraTl:false,
            paraDolar:false,
            paraEuro:false,
            paraSterlin:false,
            aramaKurumici:false,
            aramaKurumdisi:false,
            aramaUlusal:false,
            aramaUluslararasi:false,
            aramaGunluk:false,
            aramaBirkez:false,
            aramaAylik:false,
            aramaYillik:false,
            aramaHepsi:false,
            aramaHibrit:false,
            aramaDijital:false,
            aramaYuzyuze:false,
            aramaHepsi2:false,
            aramaOnayli:false,
            aramaOnaysiz:false,
            aramaHepsi3:false,
            optionsabstract:[],
             optionsetkinlikTemelTemp:'',
             optionsetkinlikTemel:[
              'FAALİYETLER',
              'GÖREV ALMA',
              'SOSYAL SORUMLULUK',
              'ROLLER',
            ],
            optionsetkinlikDegisken:[],
             optionsetkinlik:[
           'Eğitim',
            'Toplantı',
            'Sanatsal',
            'Bilimsel',
            'Telif Hakları',
            'Yarışmalar',
            'Diğer'
            ],
             optionsetkinlik2:[
            'EĞİTİM',
            'ARAŞTIRMA',
            'TOPLUMSAL KATKI',
            'SANATSAL KATKI',
            ],
            optionsetkinlik3:[
            'İNSANA YÖNELİK',
            'DOĞAYA YÖNELİK',
            'HAYVANLARA YÖNELİK',
            ],
            optionsetkinlik4:[
            'İÇ PAYDAŞ',
            'DIŞ PAYDAŞ',
            ],
            options1Gorev:[
              ' Üniversitede Jüri/Komite Üyeliği /      Sanatsal Çalışmalarda Jüri Üyeliği /    Uluslararası yarışmalarda /     Ulusal yarışmalarda',
              ' Üniversitede Jüri/Komite Üyeliği /      Mimarlık Anabilim Dallarında Jüri ve Kurul Üyelikleri / Uluslararası ve ulusal yarışmalarda jüri üyelikleri /   Kültür Bakanlığı Kültür ve Tabiat Varlıklarını Koruma Kurullarında en az iki yıllık üyelik',
              ' Üniversitede Öğrenci Danışmanlığı',
              ' Üniversitede Ders Verme',
              ' Üniversite Kurul Üyeliği',
              ' Diğer Üniversitelerde Jüri/Komite Üyeliği',
              ' Diğer Üniversitelerde Öğrenci Danışmanlığı',
              ' Diğer Üniversitelerde Ders Verme',
              ' Diğer Kurum-Kuruluşlarda Kurul Üyeliği',
              ' Bilim Kurulu Üyeliği',
              ' Oturum Başkanlığı',
              ' Davetli Konuşmacı',

            ],
            options2Gorev:[
              ' Editörlük',
              ' Dış Kaynaklı Proje',
              ' Bilimsel Kurul Üyeliği',
              ' Saha Alanı Saha Araştırmaları'


            ],
            options3Gorev:[
              ' Kamu-Özel Sektör- STK İş Birliği /      Şirket Sahibi',
              ' Kamu-Özel Sektör- STK İş Birliği /      Şirket Yöneticisi',
              ' Kamu-Özel Sektör- STK İş Birliği /      Bilirkişilik',
              ' Kamu-Özel Sektör- STK İş Birliği /      Temsilcilik',
              ' Kamu-Özel Sektör- STK İş Birliği /      Özel/Kamu Kuruluşlarına Danışmanlık',
              ' Kamu-Özel Sektör- STK İş Birliği /      Sendikal Faaliyet /     Üyelik',
              ' Kamu-Özel Sektör- STK İş Birliği /      Sendikal Faaliyet /     Yöneticilik',
              ' Kamu-Özel Sektör- STK İş Birliği /       Danışmanlık',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Gazete (Basılı/Dijital) /       Atölye/Uygulama Birimi Sorumlusu',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Gazete (Basılı/Dijital) /       Haber Muhabiri',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Gazete (Basılı/Dijital) /       Sayfa Tasarımcı',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Gazete (Basılı/Dijital) /       Yayın Koordinatörü',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Gazete (Basılı/Dijital) /       Haber Müdürü',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Gazete (Basılı/Dijital) /       Görsel Yönetmen',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Gazete (Basılı/Dijital) /       Editör',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Gazete (Basılı/Dijital) /       Redaktör',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Radyo / Haber Spiker',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Radyo / Program Sunucusu',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Radyo / Ses Kurgu',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Radyo / Ses Montaj',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Radyo / Reji (Teknik Masa)',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Radyo / Atölye Sorumlusu',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Televizyon /    Reji',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Televizyon /    Yönetmen',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Televizyon /    Resim Seçici',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Televizyon /    Sesçi',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Televizyon /    Işıkçı',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Televizyon /    KC Operatörü (Altyazı)',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Televizyon /    Kameraman',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Televizyon /    Teknik Yönetmen',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Televizyon /    Playout Operatörü',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Televizyon /    Atölye Sorumlusu',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Sosyal Medya /  Sosyal Medya Sorumlusu',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Dergi / Yazı İşleri Müdürü',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Dergi / Editör',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Dergi / Editör Yardımcısı',
              ' Medya / Üniversite Bünyesindeki Medya Mecraları /       Dergi / Yayın Kurulu Üyesi',
              ' Medya / Diğer Görsel İşitsel Medya Kuruluşları /        Yapımcı/Sunucu',
              ' Medya / Diğer Görsel İşitsel Medya Kuruluşları /        Konuk – (Radyo-TV)',
              ' Medya / Diğer Basılı Medya Kuruluşları /        Dergi/Gazete Köşe Yazarı',
              ' Medya / Diğer Sosyal Medya Alanlarında /        Sosyal Medya Etkileşim',
              ' Turizm İlişkili Faaliyetler /   Rehberlik',
              ' Turizm İlişkili Faaliyetler /   ……',
              ' Bankacılık İle İlişkili Faaliyetler /   Portföy',
              ' Bankacılık İle İlişkili Faaliyetler  /  Diğer',
              ' Spor Faaliyetleri /     Hakemlik',
              ' Spor Faaliyetleri /     Antrenörlük',
              ' Spor Faaliyetleri /     Temsilcilik',
              ' Spor Faaliyetleri /     Oyunculuk',
            ],
            options4Gorev:[
              ' Kurgulama /     Yönetmen',
              ' Kurgulama /     Yardımcı Yönetmen',
              ' Kurgulama /     Görüntü Yönetmeni',
              ' Kurgulama /     Kameraman',
              ' Kurgulama /     Kurgucu',
              ' Kurgulama /     Sesçi',
              ' Kurgulama /     Senarist',
              ' Kurgulama /     Oyuncu',
              ' Senaryo Yazarlığı',
              ' Metin Yazarlığı',
              ' Şeflik',
              ' Rejisörlük',
              ' Solistlik',
              ' Yapımcı',
              ' Oyunculuk',
              ' Kameraman',
              ' Görsel efekt',
              ' Ses tasarımı',
              '         Seslendirme ',
              ' Yönetmen Yardımcısı',
              ' Görüntü Yönetmeni',
              ' Foto Muhabir',
              ' Grafik Tasarımcısı',
              ' Danışmanlık'
            ],
             options1Sosyal:[

              ' İnsana Yönelik /        Kadın',
              ' İnsana Yönelik /        Yaşlı',
              ' İnsana Yönelik /        Çocuk',
              ' İnsana Yöneliki /       Yoksulluk',
              ' İnsana Yönelik /        Engelli',
              ' İnsana Yönelik /        Sağlık Ve Spor',
              ' İnsana Yönelik /        Değerler',
              ' İnsana Yönelik /        Diğer (Kan Bağışı, Kitap Okuma, Okuma Yazma Seferberliği, Farkındalık Çalışmaları Gibi)',


            ],
            options2Sosyal:[
              ' Doğaya Yönelik /        Ağaç Dikme',
              ' Doğaya Yönelik /        Atık Toplama',
              ' Doğaya Yönelik /        Geri Dönüşüm',
              ' Doğaya Yönelik /        Enerji Tasarrufu',
              ' Doğaya Yönelik /        Temiz Su',
              ' Doğaya Yönelik /        Milli Park, Tabiat Anıtı',
              ' Doğaya Yönelik /        Çevre Düzenleme',
              ' Doğaya Yönelik /        Artık Materyalleri Yeniden Değerlendirme',
              ' Doğaya Yönelik /        Diğer..',


            ],
            options3Sosyal:[
              ' Hayvanlara Yönelik /    Barınak',
              ' Hayvanlara Yönelik /    Kedi, Köpek Evi',
              ' Hayvanlara Yönelik /    Askıda Yem-Mama-Kap',
              ' Hayvanlara Yönelik /    Diğer …',


            ],
            options1Roller:[
              ' İç Paydaş /     Birimler',
              ' İç Paydaş /     Öğrenci Toplulukları',
              ' İç Paydaş /     Öğretim Elemanı',
              ' İç Paydaş /     İdari Personel',
              ' Dış Paydaş /    Mezun',



            ],
            options2Roller:[
              ' Dış Paydaş /    Diğer Üniversiteler',
              ' Dış Paydaş /    Kamu',
              ' Dış Paydaş /    Özel Sektör',
              ' Dış Paydaş /    STK /   Dernek',
              ' Dış Paydaş /    STK /   Vakıf',
              ' Dış Paydaş /    STK /   Sendika',
              ' Dış Paydaş /    STK /   Mesleki Kuruluşlar',
              ' Dış Paydaş /    Uluslararası Kuruluşlar',



            ],

            options1:[
              ' Sürekli Eğitim --',
              ' Sertifikalı Eğitimler',
              ' 1.a. Drone-İnsansız Hava Aracı (İHA)',
              ' Diğer Yaygın Eğitimler',
              ' Açılması Planlanan Eğitimler',
              ' Sınav Etkinlikleri',
              ' Staj',
              ' Uzaktan Eğitim',
             ' Açık Dersler',
              ' Online Yaygın Eğitimler'

            ],
            options2:[
              ' Kutlama',
              ' Anma',
              ' Kongre',
              ' Sempozyum',
              ' Konferans',
              ' Panel',
              ' Seminer',
              ' Çalıştay',
              ' Program',
              ' Zirve',
              ' Gün',
              '         Buluşma',
              ' Forum',
              ' Tören',
              ' Ziyaret',
              ' Söyleşi',
              ' Sınav Görevleri',
              ' Atölye',
              ' Şenlik',
              ' Gösterim',
              ' Staj',
              ' Sunuş Yazıları',
              ' E-Bülten Yazısı',
              ' Sohbet',
              ' Rapor Yayınlama',
              ' Akademik Açılış',
              ' Tanıtım',
              ' Kurulum',
              ' Yayın',
              ' Sistem Kurulumu',

            ],
            options3:[
              ' Fonetik Sanatlar',
              ' Fonetik Sanatlar /      Müzik Teknolojisi-Uygulama',
              ' Fonetik Sanatlar /      Tonmaysterlik Projesi Gerçekleştirme',
              ' Fonetik Sanatlar /      Ses Sistemi Projesi Gerçekleştirme',
              ' Fonetik Sanatlar /      Tonmaysterlik Projesi Katılımı',
              ' Müzik Kompozisyonları',
              ' Müzik Kompozisyonları / Sahne Yapıtları (Opera-Bale-Oratoryo Vb.)',
              ' Müzik Kompozisyonları / Senfonik Yapıtlar (Senfoni, Konçerto Vb.)',
              ' Müzik Kompozisyonları / Oda Müziği, Koro ve Solo Yapıt',
              ' Müzik Kompozisyonları / Düzenlemeler',
              ' Müzik Kompozisyonları / Elektronik Müzik Yapıtları',
              ' Müzik Kompozisyonları / Oyun İçin Özgün Müzik Yapıtı',
              ' Müzik ile İlgili Diğer Faaliyetler',
              ' Müzik ile İlgili Diğer Faaliyetler /    Bireysel Dinletiler',
              ' Müzik ile İlgili Diğer Faaliyetler /    Karma Dinletiler',
              ' Müzik ile İlgili Diğer Faaliyetler /    Eşlikçi Olarak Tanıtımlar',
              ' Müzik ile İlgili Diğer Faaliyetler /    Orkestra, Opera, Bale’ de Solist Yer Alma',
              ' Müzik ile İlgili Diğer Faaliyetler /    Oda Müziği Dinletileri',
              ' Müzik ile İlgili Diğer Faaliyetler /    Orkestra (Tutti), Opera (Koro), Bale’ De (Cor De Alet) Yer Almak',
              ' Müzik ile İlgili Diğer Faaliyetler /    Radyo TV Etkinlikleri',
              ' Müzik ile İlgili Diğer Faaliyetler /    Audio Yayınları (Kaset, CD)',
              ' Müzik ile İlgili Diğer Faaliyetler /    Bireysel Dinleti Hazırlığı ve Sunumu',
              ' Müzik ile İlgili Diğer Faaliyetler /    Karma Dinleti Hazırlığı ve Sunumu',
              ' Müzik ile İlgili Diğer Faaliyetler /    Eşlikçi Olarak Dinleti Hazırlığı ve Sunumu',
              ' Müzik ile İlgili Diğer Faaliyetler /    Orkestra, Opera, Bale Etkinliklerini Hazırlama',
              ' Müzik ile İlgili Diğer Faaliyetler /    Oda Müziği Etkinliklerini Hazırlama',
              ' Müzik ile İlgili Diğer Faaliyetler  /           Radyo ve TV Yayınların Etkinliklerini Hazırlama',
              ' Müzik ile İlgili Diğer Faaliyetler  /           Audio Yayınlarını Hazırlama',
              ' Konser',
              ' Konser /        Bireysel Konser (Resital)',
              ' Konser /        Bireysel Konser (Resital) /     Solist Saz',
              ' Konser /        Bireysel Konser (Resital) /     Solist Ses',
              ' Konser /        Bireysel Konser (Resital) /     Eşlikçi',
              ' Konser /        Bireysel Konser (Resital) /     Korist',
              ' Konser /        Toplu Konser',
              ' Konser /        Toplu Konser /  Şef',
              ' Konser /        Toplu Konser /  Solist Saz',
              ' Konser /        Toplu Konser /  Solist Ses',
              ' Konser /        Toplu Konser /  Eşlikçi',
              ' Konser /        Toplu Konser /  Korist',
              ' Atölye Çalışması',
              ' Atölye Çalışması /      Düzenleyici',
              ' Atölye Çalışması /      Eşlikçi',
              ' Koro Çalışması',
              ' Koro Çalışması /        Şef',
              ' Koro Çalışması /        Korist',
              ' Koro Çalışması /        Eşlikçi',
              ' Sanat Koleksiyonu',
              ' Sanat Koleksiyonu /     Resmi Koleksiyon',
              ' Sanat Koleksiyonu /     Özel Koleksiyon',
              ' Radyo Etkinlikleri',
              ' Radyo Etkinlikleri /    Yapımcı',
              ' Radyo Etkinlikleri /    Sunucu',
              ' Radyo Etkinlikleri /    Konuk',
              ' Radyo Etkinlikleri /    Eşlikçi',
              ' Radyo Etkinlikleri /    Yönetmen',
              ' Radyo Etkinlikleri /    Görüntü Yönetmen',
              ' Radyo Etkinlikleri /    Senaryo Yazarı',
              ' Ses Yayınları (CD, Dijital)',
              ' Ses Yayınları (CD, Dijital) /   İcracı',
              ' Ses Yayınları (CD, Dijital) /   Eşlikçi',
              ' Ses Yayınları (CD, Dijital) /   Düzenleyici',
              ' Film',
              ' Film /  Kısa Film',
              ' Film /  Kısa Film /     Yönetmen',
              ' Film /  Kısa Film /     Görüntü Yönetmeni',
              ' Film /  Kısa Film /     Senaryo Yazarı',
              ' Film /  Uzun Metrajlı Film',
              ' Film /  Uzun Metrajlı Film /    Yönetmen',
              ' Film /  Uzun Metrajlı Film /    Görüntü Yönetmeni/Kurgu',
              ' Film /  Uzun Metrajlı Film /    Senaryo Yazarı',
              ' Film /  TV Filmleri/Diziler     Yönetmen',
              ' Film /  TV Filmleri/Diziler     Görüntü Yönetmen',
              ' Film /  TV Filmleri/Diziler     Senaryo Yazarı',
              ' Film /  TV Filmleri/Diziler     Yapımcı',
              ' Film /  TV Filmleri/Diziler     Sunucu',
              ' Film /  TV Filmleri/Diziler     Konuk Oyuncu',
              ' Film /  TV Filmleri/Diziler     Senaryo Yazarlığı',
              ' Film /  TV Filmleri/Diziler     Eşlikçi',
              ' Film /  Reklam ve Tanıtım Filmleri      Metin Yazarı',
              ' Film /  Reklam ve Tanıtım Filmleri      Yönetmen',
              ' Film /  Reklam ve Tanıtım Filmleri      Kameraman',
              ' Film /  Reklam ve Tanıtım Filmleri      Grafik Tasarımcısı',
              ' Film /  Reklam ve Tanıtım Filmleri      Yaratıcı Yönetmen',
              ' Film /  Reklam ve Tanıtım Filmleri      Atölye Sorumlusu',
              ' Film /  TV Programları',
              ' Film /  TV Programları /        Yönetmen',
              ' Film /  TV Programları /        Görüntü yönetmeni',
              ' Film /  TV Programları /        Senaryo yazarı',
              ' Film /  TV Programları /        Yapımcı',
              ' Film /  TV Programları /        Sunucu',
              ' Film /  TV Programları /        Kameraman',
              ' Film /  TV Programları /        Metin yazarı',
              ' Film /  Belgesel',
              ' Film /  Belgesel /      Yönetmen',
              ' Film /  Belgesel /      Görüntü yönetmeni',
              ' Film /  Belgesel /      Senaryo yazarı',
              ' Film /  Belgesel /      Yapımcı',
              ' Film /  Belgesel /      Sunucu',
              ' Film /  Belgesel /      Metin Yazarı',
              ' Film /  Kamu Spotu',
              ' Sergi',
              ' Sergi / Bireysel (Kişisel) Sergiler',
              ' Sergi / Bireysel (Kişisel) Sergiler /   Bianeller,',
              ' Sergi / Bireysel (Kişisel) Sergiler /   Trianeller',
              ' Sergi / Bireysel (Kişisel) Sergiler /   Performans Sergisi',
              ' Sergi / Bireysel (Kişisel) Sergiler /   Devlet Resim ve Heykel Sergisi',
              ' Sergi / Bireysel (Kişisel) Sergiler /   Üniversitelerin Düzenlediği Sergiler',
              ' Sergi / Bireysel (Kişisel) Sergiler /   Performans Sergisi',
              ' Sergi / Bireysel (Kişisel) Sergiler /   Sanat Sempozyumu’nda Sergi',
              ' Sergi / Bireysel (Kişisel) Sergiler /   Kuratöryel Seçki Sergisi',
              ' Sergi / Bireysel (Kişisel) Sergiler /   Kamu Kuruluşlarınca Düzenlenen Sergiler',
              ' Sergi / Bireysel (Kişisel) Sergiler /   Özel Kuruluşlarca Düzenlenen Sergiler',
              ' Sergi / Bireysel (Kişisel) Sergiler /   Uluslararası Sergiler',
              ' Sergi / Bireysel (Kişisel) Sergiler /   Ulusal Sergiler',
              ' Sergi / Bireysel (Kişisel) Sergiler /   Sanat Sempozyumları',
              ' Sergi / Bireysel (Kişisel) Sergiler /   Sanat Sempozyumları /   Sempozyuma Katılım',
              ' Sergi / Bireysel (Kişisel) Sergiler /   Sanat Sempozyumları /   Sempozyum Düzenleme',
              ' Grup Sergiler',
              ' Grup Sergiler / Bianeller',
              ' Grup Sergiler / Trianeller',
              ' Grup Sergiler / Performans Sergisi',
              ' Grup Sergiler / Devlet Resim ve Heykel Sergisi',
              ' Grup Sergiler / Üniversitelerin Düzenlediği Sergiler',
              ' Grup Sergiler / Performans Sergisi',
              ' Grup Sergiler / Sanat Sempozyumu’nda Sergi',
              ' Grup Sergiler / Kuratöryel Seçki Sergisi',
              ' Grup Sergiler / Kamu Kuruluşlarınca Düzenlenen Sergiler',
              ' Grup Sergiler / Özel Kuruluşlarca Düzenlenen Sergiler',
              ' Grup Sergiler / Uluslararası Sergiler',
              ' Grup Sergiler / Ulusal Sergiler',
              ' Grup Sergiler / Sanat Sempozyumları /   Sempozyuma Katılım',
              ' Grup Sergiler / Sanat Sempozyumları /   Sempozyum Düzenleme',
              ' Karma Sergiler',
              ' Karma Sergiler /        Bianeller',
              ' Karma Sergiler /        Trianeller',
              ' Karma Sergiler /        Performans Sergisi',
              ' Karma Sergiler /        Devlet Resim ve Heykel Sergisi',
              ' Karma Sergiler /        Üniversitelerin Düzenlediği Sergiler',
              ' Karma Sergiler /        Performans Sergisi',
              ' Karma Sergiler /        Sanat Sempozyumu’nda Sergi',
              ' Karma Sergiler /        Kuratöryel Seçki Sergisi',
              ' Karma Sergiler /        Kamu Kuruluşlarınca Düzenlenen Sergiler',
              ' Karma Sergiler /        Özel Kuruluşlarca Düzenlenen Sergiler',
              ' Karma Sergiler /        Uluslararası Sergiler',
              ' Karma Sergiler /        Ulusal Sergiler',
              ' Karma Sergiler /        Sanat Sempozyumları',
              ' Karma Sergiler /        Sanat Sempozyumları /   Sempozyuma Katılım',
              ' Karma Sergiler /        Sanat Sempozyumları /   Sempozyum Düzenleme',
              ' Gösteri',
              ' Gösterim /      Kısa Metraj',
              ' Gösterim /      Uzun Metraj',
              ' Gösterim /      Festival',
              ' Gösterim /      Ses/Görüntü Kaydı',

              '         Festival /      Film Festivali Düzenleme',
              '         Festival /      Film Festivaline Film ile Katılım',
              ' Belge Çözümleme ve Restorasyon',

              ' Belge Çözümleme ve Restorasyon /        Belge Çözümlemesi ve Yayını /   Geleneksel Türk El Sanatları ile Başbakanlık Arşivi, Topkapı Sarayı, Vakıflar Genel Müdürlüğü Gibi Kamu Kuruluşlarında Muhafaza Edilen Belgelerin Çözümlenmesi ve Yayını',
              ' Belge Çözümleme ve Restorasyon /        Restorasyon /   Taşınmaz Eski Eser Restorasyonu',
              ' Belge Çözümleme ve Restorasyon /        Restorasyon /   Taşınabilir Eski Eser Restorasyonu',
              ' Restorasyon',
              ' Restorasyon /   Taşınmaz Eski Eser Restorasyonu',
              ' Restorasyon /   Taşınabilir Eski Eser Restorasyonu',
              ' Resital',
              ' Orkestra',
              ' Tiyatro',
              ' Tiyatro /       Tam Uzunlukta Bir Oyun Sergileme',
              ' Tiyatro /       Kısa Oyun Sergilemek',
              ' Tiyatro /       Oyun, Film ve Dia Gösterileri İçin Müzik Seçimi',
              ' Dans',
              ' Dans /  Yönetmenlik',
              ' Dans /  Yönetmen Yardımcılığı',
              ' Dans /  Koreograflık',
              ' Dans /  Eğitmenlik',
              ' Dans /  Solo',
              ' Dans /  Duet',
              ' Dans /  Trio Dansçılık',
              ' Dans /  Topluluk Dansçılığı',
              ' Dans /  Misafir Dansçılık',
              ' Dans /  Işık Tasarımı',
              ' Dans /  Kostüm Tasarımı',
              ' Dans /  Dekor Tasarımı',
              ' Dramaturgi',
              ' Oyun Yazarlığı',
              ' Oyun Yazarlığı /        Uzun Oyun Yazmak (Sahne, Radyo, TV ve Senaryo)',
              ' Oyun Yazarlığı /        Kısa Oyun Yazmak (Sahne, Radyo, TV ve Senaryo)',
              ' Oyun Yazarlığı /        Dizi, Drama Yazmak (Radyo, TV)',
              ' Dinleti',
              ' Gösteriler',
              ' Gösteriler /    Dia Gösterileri',
              ' Gösteriler /    Multivizyon Gösterileri',
              ' Çalıştay',
              ' Çalıştay /      Workshop Yöneticiliği',
              ' Çalıştay /      Workshop',
              ' Tasarım',
              ' Tasarım /       Sahne Tasarımı',
              ' Tasarım /       Sahne Tasarımı /        Oyun, Film Televizyon Programı Prodüksiyonunda Dekor Tasarımı',
              ' Tasarım /       Sahne Tasarımı /        Oyun, Film Televizyon Programı Prodüksiyonunda Dekor Tasarımı Grubunda Görev',
              ' Tasarım /       Kostüm Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Oyun, Film Televizyon Programı Prodüksiyonunda Kostüm Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Oyun, Film Televizyon Programı Prodüksiyonunda Kostüm Tasarımı Grubunda Görev',
              ' Tasarım /       Kostüm Tasarımı /       Afiş Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Masaüstü Yayın Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Giysi Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Aksesuar Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Kumaş Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Web Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Oyun Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Kurumsal Kimlik Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Sosyal Medya Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Reklam Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Jenerik Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Ambalaj Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Tipografi Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Animasyon Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Ödül Heykelciliği Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Plaket Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Takı Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Bilgilendirme Grafiği Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Sergileme Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Çoklu Ortam Tasarımı',
              ' Tasarım /       Kostüm Tasarımı /       Aplikasyon Tasarımı',
              ' Kazı',
              ' Senfoni',
              ' Overtourism',
              ' Belgesel /      Öğrenci Tarafından',
              ' Belgesel /      Akademisyen Tarafından',
              ' Kurgu',
              ' Sinematik Görsel Efekt',
              ' Koleksiyon /    Koleksiyon Hazırlığı ve Sunumu',
              ' Koleksiyon /    Kumaş Tasarımı (Koleksiyonu)',
              ' Koleksiyon /    Giyim Tasarımı (Koleksiyonu)',
              ' Koleksiyon /    Aksesuar Tasarımı (Koleksiyonu)',
              ' Koleksiyon /    Koleksiyonda Eserler',
              ' Koleksiyon /    Resmi Koleksiyonlar',
              ' Koleksiyon /    Özel Koleksiyonlar',
              ],
              options4:[
              ' Telif Hakkı Eserleri /  Roman',
              ' Telif Hakkı Eserleri /  Şiir',
              ' Telif Hakkı Eserleri /  Beste',
              ' Telif Hakkı Eserleri /  Söz',
              ' Telif Hakkı Eserleri /  Müzik',
              ' Telif Hakkı Eserleri /  Tasarım Takı',
              ' Telif Hakkı Eserleri /  Tasarım Logo',
              ' Telif Hakkı Eserleri /  Tasarım …',
              ' Telif Hakkı Eserleri /  Akademik Ürün Öğrenci Çalışması',
              ' Telif Hakkı Eserleri /  Akademik Ürün   Akademisyen Çalışması',
              ],
              options5:[
              ' Yarışmalar',
              ' Yarışmalar /    Sanatsal Yarışmalar',
              ' Yarışmalar /    Bilimsel Yarışmalar',
              ' Yarışmalar /    Öğrenci Yarışmaları',
              ' Yarışmalar /    Akademik Personel',
              ' İdari Personel',
              ' Ödüller ',
              ' Ödüller /       Mimarlık Anabilim Dallarında Proje Yarışmaları',
              ' Ödüller /       Mimarlık Anabilim Dallarında Proje Yarışmaları /        Yarışmalarda Birincilik Ödülü',
              ' Ödüller /       Mimarlık Anabilim Dallarında Proje Yarışmaları /        Yarışmalarda Diğer Ödüller',
              ' Ödüller /       Sanatsal Ödüller',
              ' Ödüller /       Sanatsal Ödüller /      Uluslararası Ödüller',
              ' Ödüller /       Sanatsal Ödüller /      Uluslararası Ödüller /  Katılım Belgesi',
              ' Ödüller /       Sanatsal Ödüller /      Uluslararası Ödüller /  Teşekkür Belgesi',
              ' Ödüller /       Sanatsal Ödüller /      Uluslararası Ödüller /  Ödül Belgesi',
              ' Ödüller /       Sanatsal Ödüller /      Uluslararası Ödüller /  Öğrenci Çalışmaları',
              ' Ödüller /       Sanatsal Ödüller /      Üniversite Ödülleri',
              ' Ödüller /       Sanatsal Ödüller /      Üniversite Ödülleri /   Ulusal Resmi Ödüller',
              ' Ödüller /       Sanatsal Ödüller /      Üniversite Ödülleri /   Ulusal Özel Ödüller',
              ' Ödüller /       Sanatsal Ödüller /      Üniversite Ödülleri /   Öğrenci Çalışmaları',
              ' Akademik Ödüller',
              ' Akademik Ödüller /      Uluslararası Ödüller',
              ' Akademik Ödüller /      Uluslararası Ödüller /  Katılım Belgesi',
              ' Akademik Ödüller /      Uluslararası Ödüller /  Teşekkür Belgesi',
              ' Akademik Ödüller /      Uluslararası Ödüller /  Ödül Belgesi',
              ' Akademik Ödüller /      Üniversite Ödülleri',
              ' Akademik Ödüller /      Ulusal Resmi Ödüller',
              ' Akademik Ödüller /      Ulusal Özel Ödüller',
              ' Akademik Ödüller /      Öğrenci Çalışmaları',
              ],
              options6:[
              ' Diğer Faaliyetler',
              ' Diğer Faaliyetler /     Müze- Teşhir Tanzim',
              ' Diğer Faaliyetler /     Destinasyon Planlama',
              ' Diğer Faaliyetler /     Ulaşım Aracı Planlama',
              ' Diğer Faaliyetler /     Yemek Planı',
              ' Diğer Faaliyetler /     Yerel Etnografya Galerisi',
              ' Diğer Faaliyetler /     Kolokyum',
              ' Diğer Faaliyetler /     Defile',
              ' Diğer Faaliyetler /     Fuar',
              ' Diğer Faaliyetler /     Gösteri ',
              ' Diğer Faaliyetler /     Gastronomi Faaliyetleri',
              ' Diğer Faaliyetler /     Mimarlık Anabilim Dalları ',
              ' Diğer Faaliyetler /     Kültür Varlıklarını Korumaya Yönelik Faaliyetler',
              ' Diğer Faaliyetler /     Kültür Varlıklarını Korumaya Yönelik Faaliyetler /      Araştırma-Belgeleme Faaliyetleri',
              ' Diğer Faaliyetler /     Kültür Varlıklarını Korumaya Yönelik Faaliyetler /      Uygulama Faaliyetleri',
              ' İmzalanan Protokoller',


            ],
            options7:[
              ' Kongre',
              ' Sempozyum',
              ' Çalıştay',
              ' Panel',
              ' Dergi'
              ],



    }),
    computed: {
      //This is for mobile trigger
       //user() {
       // return this.obj.user
      //},
       roos() {
        return this.obj3.roos
      },
      list3() {
        if(this.roos && this.roos.data){
          this.gonderilecek3=this.roos.data
         //this.aranacakSalon=this.gonderilecek3[0].roo

          return this.roos.data
        }
        return []
      },

    },

     watch: {
       optionsetkinlikTemelTemp(val){
        this.altBaslik();
      },
      optionsetkinliktemp(val){
        this.altBaslik2();
      },
        user(val) {
        if(val) {

        }
      }
    },
     methods: {
      handleSubmit() {
          const formData = new FormData();

          formData.append('email', 'HBV maili geliyor')
          axios.post('https://eys.hacibayram.edu.tr:8081/api/email-deneme', formData, {
          }).then((res) => {
            console.log(res)
          })
        },
       altBaslik(){
         if(this.optionsetkinlikTemelTemp=="FAALİYETLER"){}
          this.optionsetkinlikDegisken=this.optionsetkinlik
         if(this.optionsetkinlikTemelTemp=="GÖREV ALMA")
          this.optionsetkinlikDegisken=this.optionsetkinlik2
         if(this.optionsetkinlikTemelTemp=="SOSYAL SORUMLULUK")
          this.optionsetkinlikDegisken=this.optionsetkinlik3
         if(this.optionsetkinlikTemelTemp=="ROLLER")
          this.optionsetkinlikDegisken=this.optionsetkinlik4
      },
      altBaslik2(){
        if(this.optionsetkinliktemp=='Eğitim'){
            this.optionsabstract= this.options1
        }
        else if(this.optionsetkinliktemp=='Toplantı'){
            this.optionsabstract= this.options2
        }
        else if(this.optionsetkinliktemp=='Sanatsal'){
            this.optionsabstract= this.options3
        }
        else if(this.optionsetkinliktemp=='Telif Hakları'){
            this.optionsabstract= this.options4
        }
        else if(this.optionsetkinliktemp=='Yarışmalar'){
            this.optionsabstract= this.options5
        }
        
         else if(this.optionsetkinliktemp=='Diğer'){
            this.optionsabstract= this.options6
        }
         else if(this.optionsetkinliktemp=='Bilimsel'){
            this.optionsabstract= this.options7
        }
        //roller
         else if(this.optionsetkinliktemp=='İÇ PAYDAŞ'){
            this.optionsabstract= this.options1Roller
        }
         else if(this.optionsetkinliktemp=='DIŞ PAYDAŞ'){
            this.optionsabstract= this.options2Roller
        }


        //toplumsal

         else if(this.optionsetkinliktemp=='İNSANA YÖNELİK'){
            this.optionsabstract= this.options1Sosyal
        }
         else if(this.optionsetkinliktemp=='DOĞAYA YÖNELİK'){
            this.optionsabstract= this.options2Sosyal
        }
         else if(this.optionsetkinliktemp=='HAYVANLARA YÖNELİK'){
            this.optionsabstract= this.options3Sosyal
        }

        //görevler
        else if(this.optionsetkinliktemp=='EĞİTİM'){
            this.optionsabstract= this.options1Gorev
        }
         else if(this.optionsetkinliktemp== 'ARAŞTIRMA'){
            this.optionsabstract= this.options2Gorev
        }
         else if(this.optionsetkinliktemp=='TOPLUMSAL KATKI'){
            this.optionsabstract= this.options3Gorev
        }
        else if(this.optionsetkinliktemp=='SANATSAL KATKI'){
            this.optionsabstract= this.options4Gorev
        }
      },
       hepsi1(){
          if(this.aramaHepsi){
            this.aramaBirkez=true
            this.aramaGunluk=true
            this.aramaAylik=true
            this.aramaYillik=true
          }
           if(!this.aramaHepsi){
             this.aramaBirkez=false
            this.aramaGunluk=false
            this.aramaAylik=false
            this.aramaYillik=false
          }
       },
       hepsi2(){
           if(this.aramaHepsi2){
            this.aramaHibrit=true
            this.aramaDijital=true
            this.aramaYuzyuze=true
          }
           if(!this.aramaHepsi2){
            this.aramaHibrit=false
            this.aramaDijital=false
            this.aramaYuzyuze=false
          }
       },
       hepsi3(){
           if(this.aramaHepsi3){
            this.aramaOnaysiz=true
            this.aramaOnayli=true
          }
           if(!this.aramaHepsi3){
            this.aramaOnaysiz=false
            this.aramaOnayli=false
          }
       },
       aramaParametre(){

          if(this.max==null){
                this.max=999999999

          }
          console.log(this.optionsetkinliktemp+" !!!!!!!!!!!!!! "+this.digertemp)

          this.$router.push({name: 'etkinlik-sonuclar' ,
          params: {

               parametre1:this.aranacakSalon,
               parametre2:this.aranacakTarih1,
               parametre3:this.aranacakTarih2,

               parametre5:this.optionsetkinliktemp,
               parametre6:this.digertemp,
               parametre7:this.aramaSergi,



               parametre8:this.aramaAkademik,
               parametre9:this.aramaIdari,
               parametre10:this.aramaOgrenci,
               parametre11:this.aramaDiger,
               parametre12:this.aramaTurkce,
               parametre13:this.aramaIngilizce,
               parametre14:this.aramaArapca,
               parametre15:this.aramaAlmanca,
               parametre16:this.min,
               parametre17:this.max,
               parametre18:this.paraTl,
               parametre19:this.paraDolar,
               parametre20:this.paraEuro,
               parametre21:this.paraSterlin,
               parametre22:this.aramaKurumici,
               parametre23:this.aramaKurumdisi,
               parametre24:this.aramaUlusal,
               parametre25:this.aramaUluslararasi,
               parametre26:this.aramaGunluk,
               parametre27:this.aramaAylik,
               parametre28:this.aramaYillik,
               parametre29:this.aramaHepsi,
               parametre30:this.aramaHibrit,
               parametre31:this.aramaDijital,
               parametre32:this.aramaYuzyuze,
               parametre33:this.aramaHepsi2,
               parametre34:this.aramaOnayli,
               parametre35:this.aramaOnaysiz,
               parametre36:this.aramaHepsi3,
               parametre37:this.aramaBirkez,
               parametre38:this.etkinlikId,

            }})

       },
      aramaFunc(){
        this.arama= !this.arama



      },
      get3() {
        const params = this.getRequestParams(
          "",
          1,
          200
        );

        this.loading = true
        this.obj3.getAll(params)
      },
    },
    mounted() {
        this.optionsetkinlikDegisken=this.optionsetkinlik
        this.get3();
        var today = new Date();
          var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
         var a=''+today.getFullYear();
         var b='-99'
         var c='-'+today.getDate();



            var x= today.getMonth()+1
            var y=''
            if(x<10){
              y='0'+x
            }else{
              y=''+x
            }

             var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0');
            var yyyy = today.getFullYear();
            today = yyyy + '-' + mm + '-' + dd;
             this.aranacakTarih2=today
            this.aranacakTarih1=this.aranacakTarih2

    }
  }
</script>

<style>

.mdl-textfield:not(.is-dirty) input::-webkit-datetime-edit {
     color: transparent;
}

input[value=""]::-webkit-datetime-edit{ color: transparent; }
input:focus::-webkit-datetime-edit{ color: #000; }
.gosterme{
  display:none;
}
.cardxy{
  border-style: solid;
  border-width: 3px;
  border-radius:5px;
}
.cardxyz{
  border-style: solid;
  border-width: 3px;
  border-radius:5px;
  width:60%;
  margin-left:18%;
}
.radioClass{
  margin:5%;
}
.arama1{
 display:inline-block;
 margin-left:16%;
margin-top:1%;
}
.arama1ttt{
 display:inline-block;
 margin-left:5%;

}
.aramaTurRoof{
display:inline-block;
 width:40%;

}
.aramaFon{
 margin-left:6%;
margin-top:1%;
}
.aramaFon2{
 margin-left:6%;
  margin-top:1%;
   margin-bottom:2.8%;
}
.arama111{
  display:inline-block;
 margin-left:16%;
 width: 65%;
margin-top:1%;
 border-style: solid;
  border-width: 1px;
  border-radius:5px;
}
.digerr2{
  margin-top:2%;
}
.arama2{
 display:inline-block;
 margin-left:6%;
 margin-bottom:2.4%;
}
.arama3{
 display:inline-block;
 margin-left:10%;
margin-top:1%;
}
.arama4{
 display:inline-block;
 margin-left:16%;
margin-top:1%;
}

.minn{
  display:inline-block;
   width:43%;
   margin-top:4%;

    margin-bottom:4%;
}
.aramaButonu{
  margin-top:4%;
  margin-left:43%;
}
.maxx{
  display:inline-block;
   width:43%;
    margin-top:4%;
   margin-left:2%;


}


.aramabutton{
  margin-left:85%;
  margin-bottom:4%;
  color:white;
  font-size:13px;
}
.oldEvent{
   margin-left:32%;
  margin-bottom:4%;
  color:white;
  font-size:17px;
}

.newEvent{
  margin-left:5%;
  margin-bottom:4%;
  color:white;
  font-size:17px;
}
.aramasalon{
    border-style: solid;
  border-width: 1px;
  border-radius:5px;

}
.elementSalon2{
  margin-left:4%; display:inline-block;
  width:32%;
  padding-top:2%;
  padding-bottom:2%;
}
.radiolar{
  margin-top: 3%;
  border-style: solid;
  border-width: 1px;
  border-radius:5px;
}
.radiolar2{
  display:inline-block;
  margin-top: 3%;

  border-style: solid;
  border-width: 1px;
  border-radius:5px;
  width: 20%;
}
.radiolar33{
  display:inline-block;
  margin-top: 2%;
  margin-right: 1%;
  border-style: solid;
  border-width: 1px;
  border-radius:5px;
  width: 30%;
  position: static;
}
.radiolar331{
  display:inline-block;
  margin-right: 1%;
  border-style: solid;
  border-width: 1px;
  border-radius:5px;
  width: 100%;

}
.dotMyst{
  font-size:1px;
}
.radiolar3312{
  display:inline-block;

  margin-right: 1%;
  border-style: solid;
  border-width: 1px;
  border-radius:5px;
  width: 100%;
}
.girisbuton{
  color:white;
}
.radiolar332{
  margin-top: 5%;
  margin-right: 1%;
  border-style: solid;
  border-width: 1px;
  border-radius:5px;
  width: 100%;
  position: static;
}
.radiolar3322{
  margin-top: 2%;
  margin-right: 1%;
  border-style: solid;
  border-width: 1px;
  border-radius:5px;
  width: 100%;
}
.yardimRadio{
   margin-top: 1.7%;
  display:inline-block;

  width: 22%;
  position:absolute;
}
.yardimRadio2{
   margin-top: 1.7%;
    margin-left: 23%;
  display:inline-block;

  width: 31%;
  position:absolute;
}
.radiolar333{
  display:inline-block;
  margin-top: 1%;
  margin-right: 1%;
  border-style: solid;
  border-width: 1px;
  border-radius:5px;
  width: 71%;
  position: static;
}
.radiolar34{
  display:inline-block;
  margin-top: 13%;
  margin-right: 3%;
  border-style: solid;
  border-width: 1px;
  border-radius:5px;
  width: 25%;
}
.radiolar3{
  display:inline-block;
  margin-top: 3%;
  margin-right: 3%;
  border-style: solid;
  border-width: 1px;
  border-radius:5px;
  width: 35%;
}
.dates{
  margin-top: 3%;
  border-style: solid;
  border-width: 1px;
  border-radius:5px;
}
.tutucu2{

}


.v-messages.theme--light{
  display:none !important;
}
.v-input.d-inline-block.theme--light.v-input--selection-controls.v-input--checkbox{
  height:3%;
  margin-left:5%;
}

.baslik{
   margin-left:5%;
    margin-top:5%;
}
.tarihler{
  width:50%;
display:inline-block;
}
.tar11{
  margin-top:3%; margin-left:15%; display:inline-block; width: 30%;
}
.turClass{
   margin-top:3%;
  margin-left:8%;

  width:100%;
}
.widthsel{
  width:90%;
}
.widthsel2{
  margin-bottom:10%;
  width:90%;
}

.vs-con-table.stripe .tr-values:nth-child(2n) {
    background: #F0F0F0 !important;
}
.kirmizi{
  display:inline-block;
  color:red;
  line-height: 1.6;
}

.yaziLine{
  line-height: 2;
}
</style>
